




import { DateTime } from "luxon";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class RelativeTime extends Vue {
  @Prop({ required: true }) private date!: Date;

  private get luxon() {
    return DateTime.fromJSDate(this.date);
  }

  private get iso() {
    return this.luxon.toISO();
  }

  private get absolute() {
    return this.luxon.toLocaleString(DateTime.DATETIME_FULL);
  }

  private get relative() {
    const luxon = this.luxon;
    const diff = Math.abs(luxon.diffNow("seconds").seconds);
    if (diff < 30) {
      return "just now";
    } else {
      return luxon.toRelative();
    }
  }
}
